angular.module('controllers').controller('stockInputController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud', 'Mqtt', '$sce', '$timeout',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud, Mqtt, $sce, $timeout) {

		$rootScope.path = '/stock-input';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'stock-input';
		$scope.pathTemplate = 'food/stockinputs';
		$scope.title = 'Stoc intrari';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'id';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'desc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'ingredient_name':{'label':'Nume ingredient', 'filter':1, 'filterType':'input'},
			'stock_quantity':{'label':'Cantitate', 'filter':1, 'filterType':'input'},
			'stock_unit':{'label':'Unitate de masura', 'filter':1, 'filterType':'input'},
			'stock_price':{'label':'Pret de referinta', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.recipeUnits = {};
		$scope.recipeUnits.options = [
				{'id':0, 'value' : ''},
				{'id':1, 'value' : 'kg'},
				{'id':2, 'value' : 'l'},
				{'id':3, 'value' : 'buc'}
		];
		$scope.additionals['recipeUnits'] = $scope.recipeUnits;

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);
		$scope.additionals['recipe_unit_string'] = JSON.stringify($scope.recipeUnits.options);

		$scope.additionals['content_type'] = 'form-urlencoded';
    $scope.additionals['columnDisplay'] = 'stock_input_name';

		$scope.additionals['getIngredients'] = function (search, key) {
				if (!angular.isUndefined(search)) {
					if (search != '' && search != 'undefined' && search.length >= 2) {
						var pathIngredient = 'search=' + search;
					}
				}
				$scope.additionals['errors'] = {};
				if (!angular.isUndefined(pathIngredient) && pathIngredient != 'undefined') {
					return Crud.get($scope.path + '/getIngredients?' + pathIngredient)
						.then(function (data) {
							if (!angular.isUndefined(key)) {
									if (angular.isUndefined($scope.additionals['ingredients'])) {
											$scope.additionals['ingredients'] = [];
									}
									$scope.additionals['ingredients'][key] = data.data.ingredients;
							} else {
									$scope.additionals['ingredients'] = data.data.ingredients;
							}
							return data.data.ingredients;
						});
				} else {
					return [];
				}
		}

		/* close field */
		$scope.additionals['closeField'] = function (paramName, model, key) {
				if (!angular.isUndefined(key)) {
						model[paramName] = '';
				} else {
						model[paramName] = '';
				}
		}
		/* change field */
		$scope.additionals['changeField'] = function(model, prop, key) {
				if(prop == 'ingredient') {
						if(!angular.isUndefined(model) ) {
								model.ingredient_new = false;
						}
				}
		}

		$scope.additionals['function'] = function(ev, data) {
				if($scope.action == 'updatemultiple') {
						$scope.additionals['selectedItemIngredientMultiple'] = [];
				} else {
						$scope.additionals['selectedItemIngredient'] = '';
				}
		}

		$scope.additionals['internFunction'] = function(ev, data) {
					if($scope.action == 'updatemultiple') {

						  angular.forEach(data, function (item, key) {
									if (data['ingredient_name'] != '' && $scope.additionals['ingredients']) {
										 var checkIngredientId = $scope.additionals['checkField']($scope.additionals['ingredients'][key], 'id', 'ingredient_name', item['ingredient_name']);
										 if (checkIngredientId) {
												 item.ingredient_id = checkIngredientId;
										 } else {
												 item.ingredient_id = 0;
										 }
										 var checkIngredientName = $scope.additionals['checkField']($scope.additionals['ingredients'][key], 'ingredient_name', 'ingredient_name', item['ingredient_name']);
										 if (checkIngredientName) {
												 item.ingredient_name = checkIngredientName;
										 }
									}
							});

				} else {
						if (data['ingredient_name'] != '' && $scope.additionals['ingredients']) {
							 var checkIngredientId = $scope.additionals['checkField']($scope.additionals['ingredients'], 'id', 'ingredient_name', data['ingredient_name']);
							 if (checkIngredientId) {
									 data.ingredient_id = checkIngredientId;
							 } else {
									 data.ingredient_id = 0;
							 }
							 var checkIngredientName = $scope.additionals['checkField']($scope.additionals['ingredients'], 'ingredient_name', 'ingredient_name', data['ingredient_name']);
							 if (checkIngredientName) {
									 data.ingredient_name = checkIngredientName;
							 }
						}
				}
		}

		$scope.additionals['functionResult'] = function(ev, data) {
			// if($scope.action == 'updatemultiple') {
			// 		if (!angular.isUndefined($scope.modelsData)) {
			// 				angular.forEach($scope.modelsData, function (item, key) {
			// 						if (item.selected !== false) {
			// 								if (!angular.isUndefined($scope.modelsData[key].stock_input_name)) {
			// 										$scope.modelsData[key].stock_input_name = $scope.additionals['formatTextResult']($scope.modelsData[key].stock_input_name);
			// 								}
			// 						}
			// 				});
			// 		}
			//
			// } else {
			// 		if (!angular.isUndefined($scope.modelData.stock_input_name)) {
			// 			$scope.modelData.stock_input_name = $scope.additionals['formatTextResult']($scope.modelData.stock_input_name);
			// 		}
			// }
		}

  }]
);
